require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/script-loader/addScript.js")(require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/raw-loader/index.js!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/@webcomponents/custom-elements/custom-elements.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/@webcomponents/custom-elements/custom-elements.min.js
// module id = 262
// module chunks = 3